export { VitalsApi, VitalsAggregateMergedResult } from './VitalsApi';
